/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Synthetic, SyntheticInterface } from "../Synthetic";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "tokenName",
        type: "string",
      },
      {
        internalType: "string",
        name: "tokenSymbol",
        type: "string",
      },
      {
        internalType: "uint8",
        name: "tokenDecimals",
        type: "uint8",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "roleId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newMember",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "manager",
        type: "address",
      },
    ],
    name: "AddedSharedMember",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "roleId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "oldMember",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "manager",
        type: "address",
      },
    ],
    name: "RemovedSharedMember",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "roleId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newMember",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "manager",
        type: "address",
      },
    ],
    name: "ResetExclusiveMember",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "roleId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "newMember",
        type: "address",
      },
    ],
    name: "addMember",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "roleId",
        type: "uint256",
      },
    ],
    name: "getMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "roleId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "memberToCheck",
        type: "address",
      },
    ],
    name: "holdsRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "roleId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "memberToRemove",
        type: "address",
      },
    ],
    name: "removeMember",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "roleId",
        type: "uint256",
      },
    ],
    name: "renounceMembership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "roleId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "newMember",
        type: "address",
      },
    ],
    name: "resetMember",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "addMinter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "removeMinter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "addBurner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "removeBurner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "resetOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "isMinter",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "isBurner",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "0x60806040523480156200001157600080fd5b506040516200213338038062002133833981810160405260608110156200003757600080fd5b81019080805160405193929190846401000000008211156200005857600080fd5b9083019060208201858111156200006e57600080fd5b82516401000000008111828201881017156200008957600080fd5b82525081516020918201929091019080838360005b83811015620000b85781810151838201526020016200009e565b50505050905090810190601f168015620000e65780820380516001836020036101000a031916815260200191505b50604052602001805160405193929190846401000000008211156200010a57600080fd5b9083019060208201858111156200012057600080fd5b82516401000000008111828201881017156200013b57600080fd5b82525081516020918201929091019080838360005b838110156200016a57818101518382015260200162000150565b50505050905090810190601f168015620001985780820380516001836020036101000a031916815260200191505b5060405260209081015185519093508592508491849184918491620001c4916003919085019062000693565b508051620001da90600490602084019062000693565b50506005805460ff1916601217905550620001fe816001600160e01b036200029916565b62000215600080336001600160e01b03620002af16565b6200023b60015b604080516000808252602082019092526001600160e01b03620003ca16565b6200024760026200021c565b50506007805460ff19166001179055506200026a6001600160e01b03620004df16565b6200027d6001600160e01b036200053916565b620002906001600160e01b036200054516565b50505062000738565b6005805460ff191660ff92909216919091179055565b826000808281526006602052604090206001015460ff166002811115620002d257fe5b1462000325576040805162461bcd60e51b815260206004820152601e60248201527f43616e6e6f74207573652061207072652d6578697374696e6720726f6c650000604482015290519081900360640190fd5b60008481526006602052604090206001808201805460ff19168280021790555083815562000363600282018462000554602090811b620016db17901c565b60008481526006602052604081206001015460ff1660028111156200038457fe5b1415620003c35760405162461bcd60e51b815260040180806020018281038252603c8152602001806200209c603c913960400191505060405180910390fd5b5050505050565b826000808281526006602052604090206001015460ff166002811115620003ed57fe5b1462000440576040805162461bcd60e51b815260206004820152601e60248201527f43616e6e6f74207573652061207072652d6578697374696e6720726f6c650000604482015290519081900360640190fd5b600084815260066020908152604090912060018101805460ff19166002179055848155906200047f9060038301908590620016e56200056d821b17901c565b60008481526006602052604081206001015460ff166002811115620004a057fe5b1415620003c35760405162461bcd60e51b8152600401808060200182810382526038815260200180620020fb6038913960400191505060405180910390fd5b60075460ff1662000537576040805162461bcd60e51b815260206004820152601f60248201527f5265656e7472616e637947756172643a207265656e7472616e742063616c6c00604482015290519081900360640190fd5b565b6007805460ff19169055565b6007805460ff19166001179055565b6200056982826001600160e01b03620005ae16565b5050565b60005b8151811015620005a957620005a0838383815181106200058c57fe5b60200260200101516200061260201b60201c565b60010162000570565b505050565b6001600160a01b038116620005f55760405162461bcd60e51b8152600401808060200182810382526023815260200180620020d86023913960400191505060405180910390fd5b81546001600160a01b0319166001600160a01b0391909116179055565b6001600160a01b0381166200066e576040805162461bcd60e51b815260206004820152601f60248201527f43616e6e6f74206164642030783020746f20612073686172656420726f6c6500604482015290519081900360640190fd5b6001600160a01b0316600090815260209190915260409020805460ff19166001179055565b828054600181600116156101000203166002900490600052602060002090601f016020900481019282601f10620006d657805160ff191683800117855562000706565b8280016001018555821562000706579182015b8281111562000706578251825591602001919060010190620006e9565b506200071492915062000718565b5090565b6200073591905b808211156200071457600081556001016200071f565b90565b61195480620007486000396000f3fe608060405234801561001057600080fd5b506004361061018e5760003560e01c806373cc802a116100de578063a9059cbb11610097578063ab3545e511610071578063ab3545e514610540578063d97c05be14610579578063dd62ed3e146105a5578063f44637ba146105d35761018e565b8063a9059cbb146104d1578063aa271e1a146104fd578063aaa14ca3146105235761018e565b806373cc802a146103f957806374d0a6761461041f5780637cdc1cb91461044b57806395d89b4114610477578063983b2d561461047f578063a457c2d7146104a55761018e565b8063313ce5671161014b57806342966c681161012557806342966c68146103645780634334614a146103815780636be7658b146103a757806370a08231146103d35761018e565b8063313ce567146102ee578063395093511461030c57806340c10f19146103385761018e565b8063028468581461019357806306fdde03146101bb578063095ea7b31461023857806318160ddd1461027857806323b872dd146102925780633092afd5146102c8575b600080fd5b6101b9600480360360208110156101a957600080fd5b50356001600160a01b03166105f9565b005b6101c3610620565b6040805160208082528351818301528351919283929083019185019080838360005b838110156101fd5781810151838201526020016101e5565b50505050905090810190601f16801561022a5780820380516001836020036101000a031916815260200191505b509250505060405180910390f35b6102646004803603604081101561024e57600080fd5b506001600160a01b0381351690602001356106b6565b604080519115158252519081900360200190f35b6102806106d4565b60408051918252519081900360200190f35b610264600480360360608110156102a857600080fd5b506001600160a01b038135811691602081013590911690604001356106da565b6101b9600480360360208110156102de57600080fd5b50356001600160a01b0316610767565b6102f6610781565b6040805160ff9092168252519081900360200190f35b6102646004803603604081101561032257600080fd5b506001600160a01b03813516906020013561078a565b6102646004803603604081101561034e57600080fd5b506001600160a01b0381351690602001356107de565b6101b96004803603602081101561037a57600080fd5b5035610831565b6102646004803603602081101561039757600080fd5b50356001600160a01b0316610886565b6101b9600480360360408110156103bd57600080fd5b50803590602001356001600160a01b031661089c565b610280600480360360208110156103e957600080fd5b50356001600160a01b03166109b0565b6101b96004803603602081101561040f57600080fd5b50356001600160a01b03166109cb565b6101b96004803603604081101561043557600080fd5b50803590602001356001600160a01b03166109e6565b6102646004803603604081101561046157600080fd5b50803590602001356001600160a01b0316610afa565b6101c3610ba9565b6101b96004803603602081101561049557600080fd5b50356001600160a01b0316610c0a565b610264600480360360408110156104bb57600080fd5b506001600160a01b038135169060200135610c26565b610264600480360360408110156104e757600080fd5b506001600160a01b038135169060200135610c94565b6102646004803603602081101561051357600080fd5b50356001600160a01b0316610ca8565b6101b96004803603602081101561053957600080fd5b5035610cbc565b61055d6004803603602081101561055657600080fd5b5035610db6565b604080516001600160a01b039092168252519081900360200190f35b6101b96004803603604081101561058f57600080fd5b50803590602001356001600160a01b0316610e38565b610280600480360360408110156105bb57600080fd5b506001600160a01b0381358116916020013516610f4c565b6101b9600480360360208110156105e957600080fd5b50356001600160a01b0316610f77565b610601610f91565b610609610fea565b61061560025b8261089c565b61061d610ff6565b50565b60038054604080516020601f60026000196101006001881615020190951694909404938401819004810282018101909252828152606093909290918301828280156106ac5780601f10610681576101008083540402835291602001916106ac565b820191906000526020600020905b81548152906001019060200180831161068f57829003601f168201915b5050505050905090565b60006106ca6106c3611005565b8484611009565b5060015b92915050565b60025490565b60006106e78484846110f5565b61075d846106f3611005565b61075885604051806060016040528060288152602001611821602891396001600160a01b038a16600090815260016020526040812090610731611005565b6001600160a01b03168152602081019190915260400160002054919063ffffffff61125c16565b611009565b5060019392505050565b61076f610f91565b610777610fea565b610615600161060f565b60055460ff1690565b60006106ca610797611005565b8461075885600160006107a8611005565b6001600160a01b03908116825260208083019390935260409182016000908120918c16815292529020549063ffffffff6112f316565b600060016107ec8133610afa565b6108275760405162461bcd60e51b81526004018080602001828103825260228152602001806117ff6022913960400191505060405180910390fd5b61075d848461134d565b600261083d8133610afa565b6108785760405162461bcd60e51b81526004018080602001828103825260228152602001806117ff6022913960400191505060405180910390fd5b6108823383611449565b5050565b6000610890610f91565b6106ce60025b83610afa565b81600260008281526006602052604090206001015460ff1660028111156108bf57fe5b146108fb5760405162461bcd60e51b815260040180806020018281038252602c8152602001806117d3602c913960400191505060405180910390fd5b60008381526006602052604090205483906109169033610afa565b6109515760405162461bcd60e51b81526004018080602001828103825260248152602001806118d66024913960400191505060405180910390fd5b6000848152600660205260409020610972906003018463ffffffff61155116565b60405133906001600160a01b0385169086907feb3e33034c392e69263b04ec0fa376dc12784a41b6676c7f31b936cbc0fbb5af90600090a450505050565b6001600160a01b031660009081526020819052604090205490565b6109d3610f91565b6109db610fea565b610615600082610e38565b81600260008281526006602052604090206001015460ff166002811115610a0957fe5b14610a455760405162461bcd60e51b815260040180806020018281038252602c8152602001806117d3602c913960400191505060405180910390fd5b6000838152600660205260409020548390610a609033610afa565b610a9b5760405162461bcd60e51b81526004018080602001828103825260248152602001806118d66024913960400191505060405180910390fd5b6000848152600660205260409020610abc906003018463ffffffff61157316565b60405133906001600160a01b0385169086907f63502af7324ff6db91ab38f8236a648727d9385ea6c782073dd4882d8a61a48f90600090a450505050565b600082815260066020526040812060018082015460ff166002811115610b1c57fe5b1415610b3d57610b35600282018463ffffffff6115f316565b9150506106ce565b6002600182015460ff166002811115610b5257fe5b1415610b6b57610b35600382018463ffffffff61160616565b6040805162461bcd60e51b815260206004820152600e60248201526d125b9d985b1a59081c9bdb19525960921b604482015290519081900360640190fd5b60048054604080516020601f60026000196101006001881615020190951694909404938401819004810282018101909252828152606093909290918301828280156106ac5780601f10610681576101008083540402835291602001916106ac565b610c12610f91565b610c1a610fea565b61061560015b826109e6565b60006106ca610c33611005565b84610758856040518060600160405280602581526020016118fa6025913960016000610c5d611005565b6001600160a01b03908116825260208083019390935260409182016000908120918d1681529252902054919063ffffffff61125c16565b60006106ca610ca1611005565b84846110f5565b6000610cb2610f91565b6106ce6001610896565b80600260008281526006602052604090206001015460ff166002811115610cdf57fe5b14610d1b5760405162461bcd60e51b815260040180806020018281038252602c8152602001806117d3602c913960400191505060405180910390fd5b81610d268133610afa565b610d615760405162461bcd60e51b81526004018080602001828103825260228152602001806117ff6022913960400191505060405180910390fd5b6000838152600660205260409020610d82906003013363ffffffff61155116565b6040513390819085907feb3e33034c392e69263b04ec0fa376dc12784a41b6676c7f31b936cbc0fbb5af90600090a4505050565b600081600160008281526006602052604090206001015460ff166002811115610ddb57fe5b14610e175760405162461bcd60e51b815260040180806020018281038252602f8152602001806117a4602f913960400191505060405180910390fd5b6000838152600660205260409020610e3190600201611625565b9392505050565b81600160008281526006602052604090206001015460ff166002811115610e5b57fe5b14610e975760405162461bcd60e51b815260040180806020018281038252602f8152602001806117a4602f913960400191505060405180910390fd5b6000838152600660205260409020548390610eb29033610afa565b610eed5760405162461bcd60e51b81526004018080602001828103825260248152602001806118d66024913960400191505060405180910390fd5b6000848152600660205260409020610f0e906002018463ffffffff61163216565b60405133906001600160a01b0385169086907f3b855c56b409b671c7112789d022675eb639d0bcb8896f1b6197c132f799e74690600090a450505050565b6001600160a01b03918216600090815260016020908152604080832093909416825291909152205490565b610f7f610f91565b610f87610fea565b6106156002610c20565b60075460ff16610fe8576040805162461bcd60e51b815260206004820152601f60248201527f5265656e7472616e637947756172643a207265656e7472616e742063616c6c00604482015290519081900360640190fd5b565b6007805460ff19169055565b6007805460ff19166001179055565b3390565b6001600160a01b03831661104e5760405162461bcd60e51b81526004018080602001828103825260248152602001806118b26024913960400191505060405180910390fd5b6001600160a01b0382166110935760405162461bcd60e51b815260040180806020018281038252602281526020018061175c6022913960400191505060405180910390fd5b6001600160a01b03808416600081815260016020908152604080832094871680845294825291829020859055815185815291517f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b9259281900390910190a3505050565b6001600160a01b03831661113a5760405162461bcd60e51b815260040180806020018281038252602581526020018061188d6025913960400191505060405180910390fd5b6001600160a01b03821661117f5760405162461bcd60e51b81526004018080602001828103825260238152602001806117176023913960400191505060405180910390fd5b61118a838383611694565b6111cd8160405180606001604052806026815260200161177e602691396001600160a01b038616600090815260208190526040902054919063ffffffff61125c16565b6001600160a01b038085166000908152602081905260408082209390935590841681522054611202908263ffffffff6112f316565b6001600160a01b038084166000818152602081815260409182902094909455805185815290519193928716927fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef92918290030190a3505050565b600081848411156112eb5760405162461bcd60e51b81526004018080602001828103825283818151815260200191508051906020019080838360005b838110156112b0578181015183820152602001611298565b50505050905090810190601f1680156112dd5780820380516001836020036101000a031916815260200191505b509250505060405180910390fd5b505050900390565b600082820183811015610e31576040805162461bcd60e51b815260206004820152601b60248201527f536166654d6174683a206164646974696f6e206f766572666c6f770000000000604482015290519081900360640190fd5b6001600160a01b0382166113a8576040805162461bcd60e51b815260206004820152601f60248201527f45524332303a206d696e7420746f20746865207a65726f206164647265737300604482015290519081900360640190fd5b6113b460008383611694565b6002546113c7908263ffffffff6112f316565b6002556001600160a01b0382166000908152602081905260409020546113f3908263ffffffff6112f316565b6001600160a01b0383166000818152602081815260408083209490945583518581529351929391927fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef9281900390910190a35050565b6001600160a01b03821661148e5760405162461bcd60e51b81526004018080602001828103825260218152602001806118496021913960400191505060405180910390fd5b61149a82600083611694565b6114dd8160405180606001604052806022815260200161173a602291396001600160a01b038516600090815260208190526040902054919063ffffffff61125c16565b6001600160a01b038316600090815260208190526040902055600254611509908263ffffffff61169916565b6002556040805182815290516000916001600160a01b038516917fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef9181900360200190a35050565b6001600160a01b0316600090815260209190915260409020805460ff19169055565b6001600160a01b0381166115ce576040805162461bcd60e51b815260206004820152601f60248201527f43616e6e6f74206164642030783020746f20612073686172656420726f6c6500604482015290519081900360640190fd5b6001600160a01b0316600090815260209190915260409020805460ff19166001179055565b90546001600160a01b0391821691161490565b6001600160a01b03166000908152602091909152604090205460ff1690565b546001600160a01b031690565b6001600160a01b0381166116775760405162461bcd60e51b815260040180806020018281038252602381526020018061186a6023913960400191505060405180910390fd5b81546001600160a01b0319166001600160a01b0391909116179055565b505050565b6000610e3183836040518060400160405280601e81526020017f536166654d6174683a207375627472616374696f6e206f766572666c6f77000081525061125c565b6108828282611632565b60005b81518110156116945761170e8383838151811061170157fe5b6020026020010151611573565b6001016116e856fe45524332303a207472616e7366657220746f20746865207a65726f206164647265737345524332303a206275726e20616d6f756e7420657863656564732062616c616e636545524332303a20617070726f766520746f20746865207a65726f206164647265737345524332303a207472616e7366657220616d6f756e7420657863656564732062616c616e63654d7573742062652063616c6c6564206f6e20616e20696e697469616c697a6564204578636c757369766520726f6c654d7573742062652063616c6c6564206f6e20616e20696e697469616c697a65642053686172656420726f6c6553656e64657220646f6573206e6f7420686f6c6420726571756972656420726f6c6545524332303a207472616e7366657220616d6f756e74206578636565647320616c6c6f77616e636545524332303a206275726e2066726f6d20746865207a65726f206164647265737343616e6e6f742073657420616e206578636c757369766520726f6c6520746f2030783045524332303a207472616e736665722066726f6d20746865207a65726f206164647265737345524332303a20617070726f76652066726f6d20746865207a65726f206164647265737343616e206f6e6c792062652063616c6c6564206279206120726f6c65206d616e6167657245524332303a2064656372656173656420616c6c6f77616e63652062656c6f77207a65726fa2646970667358221220d345218d319ee88ce3b8d4af73e96e273dc3dcf6e6f53b224ed6906a623bfcdc64736f6c63430006060033417474656d7074656420746f2075736520616e20696e76616c696420726f6c6520746f206d616e61676520616e206578636c757369766520726f6c6543616e6e6f742073657420616e206578636c757369766520726f6c6520746f20307830417474656d7074656420746f2075736520616e20696e76616c696420726f6c6520746f206d616e61676520612073686172656420726f6c65";

type SyntheticConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SyntheticConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Synthetic__factory extends ContractFactory {
  constructor(...args: SyntheticConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    tokenName: string,
    tokenSymbol: string,
    tokenDecimals: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Synthetic> {
    return super.deploy(
      tokenName,
      tokenSymbol,
      tokenDecimals,
      overrides || {}
    ) as Promise<Synthetic>;
  }
  getDeployTransaction(
    tokenName: string,
    tokenSymbol: string,
    tokenDecimals: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      tokenName,
      tokenSymbol,
      tokenDecimals,
      overrides || {}
    );
  }
  attach(address: string): Synthetic {
    return super.attach(address) as Synthetic;
  }
  connect(signer: Signer): Synthetic__factory {
    return super.connect(signer) as Synthetic__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SyntheticInterface {
    return new utils.Interface(_abi) as SyntheticInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Synthetic {
    return new Contract(address, _abi, signerOrProvider) as Synthetic;
  }
}
